import { DownloadType } from '@/data/@types/DownloadType'
import { ItemDownloadRequest } from '@/data/@types/ItemDownloadRequest'
import { ndlPrintItemList, kojinsoushinPrintItemList } from './printModalType'

/**
 * 画像ダウンロードAPIにリクエストを送り、レスポンスのダウンロードURLをダウンロードさせる
 * @param store ストア情報
 * @param request 画像ダウンロードに渡すリクエスト
 * @param title トーストに表示するタイトル名
 */

export const downloadContents = async (store: any, request: ItemDownloadRequest, title: string, i18n: any, type: DownloadType) => {
  // トーストに表示するアイテムのタイトル名を設定
  await store.commit('SET_REQUEST_ITEM_TITLE', title)
  // 画像ダウンロードか挿絵ダウンロードか判定
  const action = type === DownloadType.IMAGE ? 'getItemDownloadUrl' : 'getPictureDownloadUrl'
  // 画像ダウンロードAPIからダウンロードURLを取得
  await store.dispatch(action, {
    request,
    errorMessagePrefix: i18n.t('header.toaster.download_error_prefix'),
    errorMessageSuffix: i18n.t('header.toaster.download_error_suffix'),
  })
  const downloadUrl = store.getters.itemDownloadUrl
  const processingStatus = store.getters.processingStatus
  if (processingStatus !== 'download_success') return
  if (downloadUrl && Object.keys(downloadUrl).length) {
    const a = document.createElement('a')
    document.body.appendChild(a)
    a.href = downloadUrl
    a.click()
    a.remove()
  }
}

/**
 * コンテンツの印刷可否情報を取得する
 * @param rule 提供制限ID（permission.rule）
 * @param store ストア情報
 * @returns コンテンツの印刷可否情報
 */
export const getPrintableFlag = (store: any, rule: string): boolean => {
  const isPersendOrLibsend = store.getters.isPersendOrLibsend // 個人送信or図書館送信アカウント
  const isSendlibraries = store.getters.isSendlibraries
  const isNdl = store.getters.location === 'ndl' || store.getters.location === 'kss'// 館内PC
  if (isNdl) {
    // 館内PCで館内プリント可能アイテムにアクセスした場合
    if (ndlPrintItemList.includes(rule)) return true
    // 館内PCで館内プリント不可アイテムにアクセスした場合
    else return false
  } else if (isPersendOrLibsend || isSendlibraries) {
    // 館外かつ個人送信、または図書館送信アカウントで個人送信プリント可能アイテムにアクセスしたとき
    if (kojinsoushinPrintItemList.includes(rule)) return true
    // 館外かつ個人送信、または図書館送信アカウントで個人送信プリント不可アイテムにアクセスしたとき
    else return false
  } else {
    // 上記のいずれもの条件に当てはまらない場合
    return false
  }
}
